var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstParchmentMarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.82 53.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b7bbc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.35,43.25c0,2.06-1.67,3.74-3.74,3.74H10.67c-2.06,0-3.74-1.67-3.74-3.74V11.21c0-2.06,1.67-3.74,3.74-3.74h35.72V.54H9.25C4.14.54,0,4.68,0,9.78v34.89c0,5.11,4.14,9.25,9.25,9.25h51.8c5.11,0,9.25-4.14,9.25-9.25v-20.24h-6.93v18.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.82,8.01c2.21,0,4-1.79,4-4s-1.79-4-4-4-4,1.79-4,4,1.79,4,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.04,8.01c2.21,0,4-1.79,4-4s-1.79-4-4-4-4,1.79-4,4,1.79,4,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.82,11.79c-2.21,0-4,1.79-4,4s1.79,4,4,4,4-1.79,4-4-1.79-4-4-4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.88,
    cy: 33.09,
    r: 8.29
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstParchmentMarkBlue);
export default __webpack_public_path__ + "static/media/INST-Parchment-mark-blue.d755ca7244d7100dd64d00d34f1b5427.svg";
export { ForwardRef as ReactComponent };